__turbopack_context__.v({
  "isSelected": "om4gKa_isSelected",
  "part": "om4gKa_part",
});
